module.exports = __webpack_public_path__ + "static/4BHK-05-Bathroom-24637cd91896be9c3bb86c1b4150fcef.jpg";